import { __extends } from "tslib";
import { IgrSelectedItemsChangedEventArgs } from "./igr-selected-items-changed-event-args";
import { ensureBool } from "igniteui-react-core";
/**
 * Provides data for the SelectedItemsChanging event.
*/
var IgrSelectedItemsChangingEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(IgrSelectedItemsChangingEventArgs, _super);
    function IgrSelectedItemsChangingEventArgs() {
        return _super.call(this) || this;
    }
    Object.defineProperty(IgrSelectedItemsChangingEventArgs.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrSelectedItemsChangingEventArgs.prototype, "cancel", {
        /**
         * Set this to true in order to stop the SelectedItems collection from changing.
        */
        get: function () {
            return this.i.cancel;
        },
        set: function (v) {
            this.i.cancel = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    return IgrSelectedItemsChangingEventArgs;
}(IgrSelectedItemsChangedEventArgs));
export { IgrSelectedItemsChangingEventArgs };
